var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M10.5 32V40M12.5 8V16M14.5 36H6.5M16.5 12H8.5M26.5 8L30.0057 16.8887C30.3815 17.8417 30.5694 18.3181 30.8571 18.7199C31.1122 19.076 31.424 19.3878 31.7801 19.6429C32.1819 19.9306 32.6583 20.1185 33.6113 20.4943L42.5 24L33.6113 27.5057C32.6583 27.8815 32.1819 28.0694 31.7801 28.3571C31.424 28.6122 31.1122 28.924 30.8571 29.2801C30.5694 29.6819 30.3815 30.1583 30.0057 31.1113L26.5 40L22.9943 31.1113C22.6185 30.1583 22.4306 29.6819 22.1429 29.2801C21.8878 28.924 21.576 28.6122 21.2199 28.3571C20.8181 28.0694 20.3417 27.8815 19.3887 27.5057L10.5 24L19.3887 20.4943C20.3417 20.1185 20.8181 19.9306 21.2199 19.6429C21.576 19.3878 21.8878 19.076 22.1429 18.7199C22.4306 18.3181 22.6185 17.8417 22.9943 16.8887L26.5 8Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.83abc869ac653665160fb2a3c87df713.svg";
export { ForwardRef as ReactComponent };